import {Component, Input} from '@angular/core';
import {CurrencyPipe, DatePipe} from '@angular/common';

@Component({
    selector: 'app-display-value',
    imports: [
        DatePipe,
        CurrencyPipe
    ],
    templateUrl: './display-value.component.html'
})
export class DisplayValueComponent {
    @Input() value: any;
    @Input() pipeType: 'date' | 'currency' | undefined;
    @Input() pipeArgs: string | undefined;

    get displayValue(): any {
        if (this.value && typeof this.value.toDate === 'function') {
            return this.value.toDate();
        }
        return this.value;
    }
}
